export default {"src":"https://static.carma.com.au/_next/static/media/play-button.27a02b98.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};